import React, { useState, useEffect } from 'react';
import api from '../api';

const cores = { navy: '#1A2233', navyD: '#253047', navyL: 'rgba(26,34,51,0.08)', gold: '#e8a020', green: '#27ae60', red: '#e74c3c', border: '#d4dde8', muted: '#6b7a8d', orange: '#D85A30' };

const Modal = ({ show, onClose, title, children, bloqueado = false }) => {
  if (!show) return null;
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 500, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}
      onClick={e => { if (e.target === e.currentTarget && !bloqueado) onClose(); }}>
      <div style={{ background: 'white', borderRadius: '20px 20px 0 0', padding: '24px 20px', width: '100%', maxWidth: 500, maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 20 }}>{title}</div>
        {children}
      </div>
    </div>
  );
};

export default function Estoque({ usuario, toast: showToastExterno }) {
  const perfisUsuario = usuario?.perfis || [usuario?.perfil];
  const isFuncionario = perfisUsuario.includes('func') &&
    !perfisUsuario.includes('ges') &&
    !perfisUsuario.includes('fin') &&
    !perfisUsuario.includes('fec');
  const isEst = perfisUsuario.includes('est');

  // Catálogo só aparece para quem tem 'est', mas se tiver 'func' precisa também ter 'orc'
  const podeVerCatalogo = perfisUsuario.includes('est') &&
    (!perfisUsuario.includes('func') || perfisUsuario.includes('orc'));

  const [subAba, setSubAba] = useState('estoque');
  const [produtos, setProdutos] = useState([]);
  const [busca, setBusca] = useState('');
  const [produtoSel, setProdutoSel] = useState(null);
  const [movimentacoes, setMovimentacoes] = useState([]);

  const [showModalNovo, setShowModalNovo] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [showModalMov, setShowModalMov] = useState(false);
  const [showModalDetalhe, setShowModalDetalhe] = useState(false);

  const [nome, setNome] = useState('');
  const [categoria, setCategoria] = useState('');
  const [fornecedor, setFornecedor] = useState('');
  const [quantidade, setQuantidade] = useState('');
  const [valorPago, setValorPago] = useState('');
  const [percLucro, setPercLucro] = useState('');
  const [valorVenda, setValorVenda] = useState('');
  const [local, setLocal] = useState('');
  const [ncm, setNcm] = useState('');
  const [csosn, setCsosn] = useState('');
  const [cfop, setCfop] = useState('');

  // Ao mudar valor pago ou % lucro → recalcula valor de venda
  const handleValorPago = (v) => {
    setValorPago(v);
    if (v && percLucro) setValorVenda((parseFloat(v) * (1 + parseFloat(percLucro) / 100)).toFixed(2));
  };
  const handlePercLucro = (v) => {
    setPercLucro(v);
    if (valorPago && v) setValorVenda((parseFloat(valorPago) * (1 + parseFloat(v) / 100)).toFixed(2));
  };
  // Ao mudar valor de venda → recalcula % lucro
  const handleValorVenda = (v) => {
    setValorVenda(v);
    if (valorPago && v && parseFloat(valorPago) > 0) {
      const perc = ((parseFloat(v) / parseFloat(valorPago)) - 1) * 100;
      setPercLucro(perc.toFixed(2));
    }
  };

  const [movTipo, setMovTipo] = useState('entrada');
  const [movQtd, setMovQtd] = useState('');
  const [movObs, setMovObs] = useState('');

  // Catálogo
  const [catalogo, setCatalogo] = useState([]);
  const [buscaCat, setBuscaCat] = useState('');
  const [showModalCatNovo, setShowModalCatNovo] = useState(false);
  const [showModalCatEdit, setShowModalCatEdit] = useState(false);
  const [catSel, setCatSel] = useState(null);
  const [catNome, setCatNome] = useState('');
  const [catCategoria, setCatCategoria] = useState('');
  const [catFornecedor, setCatFornecedor] = useState('');
  const [catValorPago, setCatValorPago] = useState('');
  const [catPercLucro, setCatPercLucro] = useState('');
  const [catValorVenda, setCatValorVenda] = useState('');
  const [catNcm, setCatNcm] = useState('');
  const [catCsosn, setCatCsosn] = useState('');
  const [catCfop, setCatCfop] = useState('');

  const handleCatValorPago = (v) => {
    setCatValorPago(v);
    if (v && catPercLucro) setCatValorVenda((parseFloat(v) * (1 + parseFloat(catPercLucro) / 100)).toFixed(2));
  };
  const handleCatPercLucro = (v) => {
    setCatPercLucro(v);
    if (catValorPago && v) setCatValorVenda((parseFloat(catValorPago) * (1 + parseFloat(v) / 100)).toFixed(2));
  };
  const handleCatValorVenda = (v) => {
    setCatValorVenda(v);
    if (catValorPago && v && parseFloat(catValorPago) > 0) {
      setCatPercLucro((((parseFloat(v) / parseFloat(catValorPago)) - 1) * 100).toFixed(2));
    }
  };

  // Equipamentos
  const [equipamentos, setEquipamentos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [showModalEquip, setShowModalEquip] = useState(false);
  const [showModalTransf, setShowModalTransf] = useState(false);
  const [equipSel, setEquipSel] = useState(null);
  const [equipNome, setEquipNome] = useState('');
  const [equipQtd, setEquipQtd] = useState(1);
  const [transfPara, setTransfPara] = useState('');
  const [buscaEquip, setBuscaEquip] = useState('');

  const [toastMsg, setToastMsg] = useState('');
  const showToast = (msg) => { setToastMsg(msg); setTimeout(() => setToastMsg(''), 3000); };

  useEffect(() => { carregar(); carregarCatalogo(); carregarEquipamentos(); carregarUsuarios(); }, []);

  const carregar = async () => {
    try { const r = await api.get('/estoque'); setProdutos(r.data); } catch {}
  };

  const carregarCatalogo = async () => {
    try { const r = await api.get('/catalogo'); setCatalogo(r.data); } catch {}
  };

  const carregarEquipamentos = async () => {
    try { const r = await api.get('/estoque/equipamentos'); setEquipamentos(r.data); } catch {}
  };

  const carregarUsuarios = async () => {
    try { const r = await api.get('/usuarios'); setUsuarios(r.data); } catch {}
  };

  const valorFinal = (vp, pl) => parseFloat(vp || 0) * (1 + parseFloat(pl || 0) / 100);

  // ── Estoque ────────────────────────────────────────────────────────────────

  const criarProduto = async () => {
    if (!nome) { showToast('Informe o nome'); return; }
    try {
      await api.post('/estoque', { nome, categoria, fornecedor, quantidade, valor_pago: valorPago, percentual_lucro: percLucro, local, ncm, csosn, cfop });
      showToast('Produto criado!');
      setShowModalNovo(false);
      setNome(''); setCategoria(''); setFornecedor(''); setQuantidade(''); setValorPago(''); setPercLucro(''); setValorVenda(''); setLocal(''); setNcm(''); setCsosn(''); setCfop('');
      carregar();
    } catch { showToast('Erro ao criar produto'); }
  };

  const editarProduto = async () => {
    if (!nome) { showToast('Informe o nome'); return; }
    try {
      await api.patch(`/estoque/${produtoSel.id}`, { nome, categoria, fornecedor, quantidade, valor_pago: valorPago, percentual_lucro: percLucro, local, ncm, csosn, cfop });
      showToast('Produto atualizado!');
      setShowModalEdit(false);
      carregar();
    } catch { showToast('Erro ao atualizar'); }
  };

  const removerProduto = async (id) => {
    if (!window.confirm('Remover este produto?')) return;
    try {
      await api.delete(`/estoque/${id}`);
      showToast('Produto removido');
      carregar();
    } catch { showToast('Erro ao remover'); }
  };

  const abrirEdicao = (p) => {
    setProdutoSel(p);
    setNome(p.nome); setCategoria(p.categoria); setFornecedor(p.fornecedor);
    setQuantidade(p.quantidade); setValorPago(p.valor_pago); setPercLucro(p.percentual_lucro);
    setValorVenda(parseFloat(p.valor_final || valorFinal(p.valor_pago, p.percentual_lucro)).toFixed(2));
    setLocal(p.local || ''); setNcm(p.ncm || ''); setCsosn(p.csosn || ''); setCfop(p.cfop || '5102');
    setShowModalEdit(true);
  };

  const abrirMovimentacao = (p) => {
    setProdutoSel(p);
    setMovTipo('entrada'); setMovQtd(''); setMovObs('');
    setShowModalMov(true);
  };

  const abrirDetalhe = async (p) => {
    setProdutoSel(p);
    try { const r = await api.get(`/estoque/${p.id}/movimentacoes`); setMovimentacoes(r.data); } catch {}
    setShowModalDetalhe(true);
  };

  const registrarMovimentacao = async () => {
    if (!movQtd) { showToast('Informe a quantidade'); return; }
    try {
      await api.post(`/estoque/${produtoSel.id}/movimentacoes`, {
        tipo: movTipo, quantidade: movQtd, observacao: movObs, usuario_id: usuario.id
      });
      showToast(movTipo === 'entrada' ? 'Entrada registrada!' : 'Saida registrada!');
      setShowModalMov(false);
      carregar();
    } catch { showToast('Erro ao registrar'); }
  };

  // ── Catálogo ───────────────────────────────────────────────────────────────

  const criarCatalogo = async () => {
    if (!catNome) { showToast('Informe o nome'); return; }
    try {
      await api.post('/catalogo', { nome: catNome, categoria: catCategoria, fornecedor: catFornecedor, valor_pago: catValorPago, percentual_lucro: catPercLucro, valor_venda: catValorVenda, ncm: catNcm, csosn: catCsosn, cfop: catCfop });
      showToast('Produto adicionado ao catálogo!');
      setShowModalCatNovo(false);
      setCatNome(''); setCatCategoria(''); setCatFornecedor(''); setCatValorPago(''); setCatPercLucro(''); setCatValorVenda(''); setCatNcm(''); setCatCsosn(''); setCatCfop('');
      carregarCatalogo();
    } catch { showToast('Erro ao criar'); }
  };

  const editarCatalogo = async () => {
    if (!catNome) { showToast('Informe o nome'); return; }
    try {
      await api.patch(`/catalogo/${catSel.id}`, { nome: catNome, categoria: catCategoria, fornecedor: catFornecedor, valor_pago: catValorPago, percentual_lucro: catPercLucro, valor_venda: catValorVenda, ncm: catNcm, csosn: catCsosn, cfop: catCfop });
      showToast('Produto atualizado!');
      setShowModalCatEdit(false);
      carregarCatalogo();
    } catch { showToast('Erro ao atualizar'); }
  };

  const removerCatalogo = async (id) => {
    if (!window.confirm('Remover este produto do catálogo?')) return;
    try {
      await api.delete(`/catalogo/${id}`);
      showToast('Produto removido do catálogo');
      carregarCatalogo();
    } catch { showToast('Erro ao remover'); }
  };

  const abrirEdicaoCatalogo = (p) => {
    setCatSel(p);
    setCatNome(p.nome); setCatCategoria(p.categoria || ''); setCatFornecedor(p.fornecedor || ''); setCatNcm(p.ncm || ''); setCatCsosn(p.csosn || ''); setCatCfop(p.cfop || '5102');
    setCatValorPago(p.valor_pago || ''); setCatPercLucro(p.percentual_lucro || '');
    const vf = parseFloat(p.valor_venda || 0) || parseFloat(p.valor_pago || 0) * (1 + parseFloat(p.percentual_lucro || 0) / 100);
    setCatValorVenda(vf.toFixed(2));
    setShowModalCatEdit(true);
  };

  const catalogoFiltrado = catalogo.filter(p =>
    p.nome.toLowerCase().includes(buscaCat.toLowerCase()) ||
    (p.categoria || '').toLowerCase().includes(buscaCat.toLowerCase()) ||
    (p.fornecedor || '').toLowerCase().includes(buscaCat.toLowerCase())
  );

  // ── Equipamentos ───────────────────────────────────────────────────────────

  const criarEquipamento = async () => {
    if (!equipNome) { showToast('Informe o nome'); return; }
    try {
      await api.post('/estoque/equipamentos', {
        nome: equipNome,
        quantidade: equipQtd,
        responsavel_id: usuario.id,
        responsavel_nome: usuario.nome,
      });
      showToast('Equipamento cadastrado!');
      setShowModalEquip(false);
      setEquipNome(''); setEquipQtd(1);
      carregarEquipamentos();
    } catch { showToast('Erro ao cadastrar equipamento'); }
  };

  const removerEquipamento = async (id) => {
    if (!window.confirm('Remover este equipamento?')) return;
    try {
      await api.delete(`/estoque/equipamentos/${id}`);
      showToast('Equipamento removido');
      carregarEquipamentos();
    } catch { showToast('Erro ao remover'); }
  };

  const abrirTransferencia = (eq) => {
    setEquipSel(eq);
    setTransfPara('');
    setShowModalTransf(true);
  };

  const transferirEquipamento = async () => {
    if (!transfPara) { showToast('Selecione o técnico'); return; }
    const novoResponsavel = usuarios.find(u => String(u.id) === String(transfPara));
    if (!novoResponsavel) return;
    try {
      await api.patch(`/estoque/equipamentos/${equipSel.id}`, {
        nome: equipSel.nome,
        quantidade: equipSel.quantidade,
        responsavel_id: novoResponsavel.id,
        responsavel_nome: novoResponsavel.nome,
      });
      showToast(`Transferido para ${novoResponsavel.nome}!`);
      setShowModalTransf(false);
      carregarEquipamentos();
    } catch { showToast('Erro ao transferir'); }
  };

  const produtosFiltrados = produtos.filter(p =>
    p.nome.toLowerCase().includes(busca.toLowerCase()) ||
    (p.categoria || '').toLowerCase().includes(busca.toLowerCase()) ||
    (p.fornecedor || '').toLowerCase().includes(busca.toLowerCase()) ||
    (p.local || '').toLowerCase().includes(busca.toLowerCase())
  );

  // Agrupa equipamentos por responsável
  const equipAgrupados = equipamentos.reduce((acc, eq) => {
    const key = eq.responsavel_nome || 'Sem responsável';
    if (!acc[key]) acc[key] = [];
    acc[key].push(eq);
    return acc;
  }, {});

  const equipFiltrados = buscaEquip
    ? equipamentos.filter(e => e.nome.toLowerCase().includes(buscaEquip.toLowerCase()) || (e.responsavel_nome || '').toLowerCase().includes(buscaEquip.toLowerCase()))
    : null;

  const cardStyle = { background: 'white', borderRadius: 14, padding: 20, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', marginBottom: 16 };
  const inputStyle = { padding: '10px 14px', border: `1.5px solid ${cores.border}`, borderRadius: 8, fontSize: 14, width: '100%', boxSizing: 'border-box' };
  const labelStyle = { fontSize: 12, fontWeight: 600, color: cores.muted, textTransform: 'uppercase', display: 'block', marginBottom: 6 };
  const btnPrimary = { padding: '10px 20px', background: cores.orange, color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' };
  const btnGhost = { padding: '10px 20px', background: '#f0f3f7', color: '#333', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' };

  return (
    <div>
      {toastMsg && (
        <div style={{ position: 'fixed', bottom: 24, right: 24, color: 'white', padding: '14px 20px', borderRadius: 8, fontSize: 14, fontWeight: 500, zIndex: 9999, background: '#4a4a4a' }}>
          {toastMsg}
        </div>
      )}

      {/* SUB-ABAS */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {[
          ['estoque', '📦 Estoque'],
          ...(podeVerCatalogo ? [['catalogo', '📋 Catálogo']] : []),
          ['equipamentos', '🔧 Equipamentos'],
        ].map(([key, label]) => (
          <button key={key} onClick={() => setSubAba(key)} style={{
            padding: '8px 18px', borderRadius: 8, border: 'none', cursor: 'pointer',
            fontWeight: 600, fontSize: 13,
            background: subAba === key ? cores.orange : 'white',
            color: subAba === key ? 'white' : cores.muted,
            boxShadow: subAba === key ? '0 2px 8px rgba(216,90,48,0.3)' : '0 2px 8px rgba(0,0,0,0.06)',
          }}>{label}</button>
        ))}
      </div>

      {/* ── ABA ESTOQUE ── */}
      {subAba === 'estoque' && (
        <>
          {/* HEADER */}
          <div style={{ ...cardStyle, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
            <div style={{ fontWeight: 700, fontSize: 16 }}>📦 Estoque</div>
            <button onClick={() => { setNome(''); setCategoria(''); setFornecedor(''); setQuantidade(''); setValorPago(''); setPercLucro(''); setLocal(''); setShowModalNovo(true); }} style={btnPrimary}>
              + Novo Produto
            </button>
          </div>

          {/* RESUMO */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 12 }}>
            {[
              ['Total Produtos', produtos.length, cores.navy],
              ['Em Estoque', produtos.filter(p => parseFloat(p.quantidade) > 0).length, cores.green],
              ['Sem Estoque', produtos.filter(p => parseFloat(p.quantidade) <= 0).length, cores.red],
            ].map(([label, val, cor]) => (
              <div key={label} style={{ background: 'white', borderRadius: 14, padding: 14, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', borderLeft: `4px solid ${cor}` }}>
                <div style={{ fontSize: 11, color: cores.muted, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>{label}</div>
                <div style={{ fontSize: 20, fontWeight: 700 }}>{val}</div>
              </div>
            ))}
          </div>

          {/* TOTAIS FINANCEIROS */}
          {!isFuncionario && (() => {
            const totalCusto = produtos.reduce((s, p) => s + parseFloat(p.valor_pago || 0) * parseFloat(p.quantidade || 0), 0);
            const totalVenda = produtos.reduce((s, p) => {
              const custo = parseFloat(p.valor_pago || 0);
              const lucro = parseFloat(p.percentual_lucro || 0);
              const venda = custo * (1 + lucro / 100);
              return s + venda * parseFloat(p.quantidade || 0);
            }, 0);
            const fmt = v => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            return (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
                <div style={{ background: 'white', borderRadius: 14, padding: 14, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', borderLeft: '4px solid #f59e0b' }}>
                  <div style={{ fontSize: 11, color: cores.muted, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>Total Custo em Estoque</div>
                  <div style={{ fontSize: 20, fontWeight: 700, color: '#f59e0b' }}>{fmt(totalCusto)}</div>
                </div>
                <div style={{ background: 'white', borderRadius: 14, padding: 14, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', borderLeft: '4px solid #7c3aed' }}>
                  <div style={{ fontSize: 11, color: cores.muted, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>Total Venda em Estoque</div>
                  <div style={{ fontSize: 20, fontWeight: 700, color: '#7c3aed' }}>{fmt(totalVenda)}</div>
                </div>
              </div>
            );
          })()}

          {/* BUSCA */}
          <div style={{ ...cardStyle, padding: '12px 16px' }}>
            <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar por nome, categoria, fornecedor ou local..."
              style={{ ...inputStyle, border: 'none', outline: 'none', fontSize: 14 }} />
          </div>

          {/* LISTA */}
          <div style={cardStyle}>
            {produtosFiltrados.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 32, color: cores.muted }}>
                <div style={{ fontSize: 40 }}>📭</div>
                <p>Nenhum produto encontrado</p>
              </div>
            ) : produtosFiltrados.map(p => (
              <div key={p.id} style={{ padding: '14px 0', borderBottom: `1px solid ${cores.border}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 10 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4 }}>{p.nome}</div>
                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                      {p.categoria && <span style={{ fontSize: 12, background: cores.navyL, color: cores.navyD, padding: '2px 8px', borderRadius: 12, fontWeight: 600 }}>{p.categoria}</span>}
                      {p.fornecedor && <span style={{ fontSize: 12, color: cores.muted }}>Fornecedor: {p.fornecedor}</span>}
                      {p.local && <span style={{ fontSize: 12, color: cores.muted }}>📍 {p.local}</span>}
                      <span style={{ fontSize: 13, fontWeight: 700, color: parseFloat(p.quantidade) > 0 ? cores.green : cores.red }}>
                        Qtd: {parseFloat(p.quantidade)}
                      </span>
                      {!isFuncionario && <span style={{ fontSize: 13 }}>Custo: <b>R$ {parseFloat(p.valor_pago).toFixed(2).replace('.', ',')}</b></span>}
                      {!isFuncionario && <span style={{ fontSize: 13 }}>Lucro: <b>{parseFloat(p.percentual_lucro)}%</b></span>}
                      {!isFuncionario && <span style={{ fontSize: 13 }}>Venda: <b style={{ color: cores.orange }}>R$ {parseFloat(p.valor_final).toFixed(2).replace('.', ',')}</b></span>}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    <button onClick={() => abrirMovimentacao(p)} style={{ padding: '5px 10px', background: '#d1f5e0', border: `1px solid ${cores.green}`, borderRadius: 6, fontSize: 12, cursor: 'pointer', color: '#155724', fontWeight: 600 }}>+/- Mov</button>
                    <button onClick={() => abrirDetalhe(p)} style={{ padding: '5px 10px', background: '#eef2ff', border: '1px solid #c7d2fe', borderRadius: 6, fontSize: 12, cursor: 'pointer', color: '#3730a3', fontWeight: 600 }}>Histórico</button>
                    <button onClick={() => abrirEdicao(p)} style={{ padding: '5px 10px', background: '#f0f3f7', border: `1px solid ${cores.border}`, borderRadius: 6, fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>Editar</button>
                    <button onClick={() => removerProduto(p.id)} style={{ padding: '5px 10px', background: '#fde8e8', border: '1px solid #f5b7b1', borderRadius: 6, fontSize: 12, cursor: 'pointer', color: '#c0392b', fontWeight: 600 }}>Remover</button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* MODAL NOVO PRODUTO */}
          <Modal show={showModalNovo} onClose={() => setShowModalNovo(false)} title="Novo Produto" bloqueado={!!(nome || categoria || fornecedor || valorPago)}>
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Nome *</label>
              <input value={nome} onChange={e => setNome(e.target.value)} placeholder="Ex: Notebook Dell" style={inputStyle} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div>
                <label style={labelStyle}>Categoria</label>
                <input value={categoria} onChange={e => setCategoria(e.target.value)} placeholder="Ex: Informatica" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Fornecedor</label>
                <input value={fornecedor} onChange={e => setFornecedor(e.target.value)} placeholder="Ex: Dell" style={inputStyle} />
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Local</label>
              <input value={local} onChange={e => setLocal(e.target.value)} placeholder="Ex: Prateleira A3, Escritório..." style={inputStyle} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>NCM <span style={{ fontSize: 10, color: cores.muted, fontWeight: 400 }}>(usado na emissão de NF-e)</span></label>
              <input value={ncm} onChange={e => setNcm(e.target.value.replace(/\D/g,'').slice(0,8))} placeholder="Ex: 84713012" maxLength={8} style={inputStyle} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div>
                <label style={labelStyle}>CSOSN <span style={{ fontSize: 10, color: cores.muted, fontWeight: 400 }}>(Simples Nacional)</span></label>
                <select value={csosn} onChange={e => setCsosn(e.target.value)} style={inputStyle}>
                  <option value="">— Selecionar —</option>
                  <option value="102">102 — Sem permissão de crédito</option>
                  <option value="400">400 — Sem ST</option>
                  <option value="500">500 — Com ST (mais comum)</option>
                  <option value="900">900 — Outros</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>CFOP</label>
                <select value={cfop} onChange={e => setCfop(e.target.value)} style={inputStyle}>
                  <option value="5102">5102 — Venda de mercadoria</option>
                  <option value="5405">5405 — Venda com ST</option>
                  <option value="5949">5949 — Outra saída</option>
                  <option value="6102">6102 — Venda interestadual</option>
                </select>
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Quantidade inicial</label>
              <input type="number" value={quantidade} onChange={e => setQuantidade(e.target.value)} placeholder="0" style={inputStyle} />
            </div>
            {!isFuncionario && (
              <>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
                  <div>
                    <label style={labelStyle}>Valor Pago (R$)</label>
                    <input type="number" step="0.01" value={valorPago} onChange={e => handleValorPago(e.target.value)} placeholder="0,00" style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>% Lucro</label>
                    <input type="number" step="0.01" value={percLucro} onChange={e => handlePercLucro(e.target.value)} placeholder="0" style={inputStyle} />
                  </div>
                </div>
                <div style={{ marginBottom: 20, padding: 12, background: '#fff3eb', borderRadius: 8 }}>
                  <label style={{ ...labelStyle, color: cores.orange }}>Valor de Venda (R$) — editável</label>
                  <input type="number" step="0.01" value={valorVenda} onChange={e => handleValorVenda(e.target.value)}
                    placeholder="0,00" style={{ ...inputStyle, fontWeight: 700, color: cores.orange, borderColor: cores.orange }} />
                </div>
              </>
            )}
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setShowModalNovo(false)} style={{ ...btnGhost, flex: 1 }}>Cancelar</button>
              <button onClick={criarProduto} style={{ ...btnPrimary, flex: 1 }}>Criar</button>
            </div>
          </Modal>

          {/* MODAL EDITAR PRODUTO */}
          <Modal show={showModalEdit} onClose={() => setShowModalEdit(false)} title="Editar Produto" bloqueado={true}>
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Nome *</label>
              <input value={nome} onChange={e => setNome(e.target.value)} style={inputStyle} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div>
                <label style={labelStyle}>Categoria</label>
                <input value={categoria} onChange={e => setCategoria(e.target.value)} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Fornecedor</label>
                <input value={fornecedor} onChange={e => setFornecedor(e.target.value)} style={inputStyle} />
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Local</label>
              <input value={local} onChange={e => setLocal(e.target.value)} placeholder="Ex: Prateleira A3, Escritório..." style={inputStyle} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>NCM <span style={{ fontSize: 10, color: cores.muted, fontWeight: 400 }}>(usado na emissão de NF-e)</span></label>
              <input value={ncm} onChange={e => setNcm(e.target.value.replace(/\D/g,'').slice(0,8))} placeholder="Ex: 84713012" maxLength={8} style={inputStyle} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div>
                <label style={labelStyle}>CSOSN <span style={{ fontSize: 10, color: cores.muted, fontWeight: 400 }}>(Simples Nacional)</span></label>
                <select value={csosn} onChange={e => setCsosn(e.target.value)} style={inputStyle}>
                  <option value="">— Selecionar —</option>
                  <option value="102">102 — Sem permissão de crédito</option>
                  <option value="400">400 — Sem ST</option>
                  <option value="500">500 — Com ST (mais comum)</option>
                  <option value="900">900 — Outros</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>CFOP</label>
                <select value={cfop} onChange={e => setCfop(e.target.value)} style={inputStyle}>
                  <option value="5102">5102 — Venda de mercadoria</option>
                  <option value="5405">5405 — Venda com ST</option>
                  <option value="5949">5949 — Outra saída</option>
                  <option value="6102">6102 — Venda interestadual</option>
                </select>
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Quantidade</label>
              <input type="number" value={quantidade} onChange={e => setQuantidade(e.target.value)} style={inputStyle} />
            </div>
            {!isFuncionario && (
              <>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
                  <div>
                    <label style={labelStyle}>Valor Pago (R$)</label>
                    <input type="number" step="0.01" value={valorPago} onChange={e => handleValorPago(e.target.value)} style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>% Lucro</label>
                    <input type="number" step="0.01" value={percLucro} onChange={e => handlePercLucro(e.target.value)} style={inputStyle} />
                  </div>
                </div>
                <div style={{ marginBottom: 20, padding: 12, background: '#fff3eb', borderRadius: 8 }}>
                  <label style={{ ...labelStyle, color: cores.orange }}>Valor de Venda (R$) — editável</label>
                  <input type="number" step="0.01" value={valorVenda} onChange={e => handleValorVenda(e.target.value)}
                    placeholder="0,00" style={{ ...inputStyle, fontWeight: 700, color: cores.orange, borderColor: cores.orange }} />
                </div>
              </>
            )}
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setShowModalEdit(false)} style={{ ...btnGhost, flex: 1 }}>Cancelar</button>
              <button onClick={editarProduto} style={{ ...btnPrimary, flex: 1 }}>Salvar</button>
            </div>
          </Modal>

          {/* MODAL MOVIMENTACAO */}
          <Modal show={showModalMov} onClose={() => setShowModalMov(false)} title={`Movimentacao — ${produtoSel?.nome}`}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
              {['entrada', 'saida'].map(t => (
                <button key={t} onClick={() => setMovTipo(t)} style={{
                  padding: 12, border: `2px solid ${movTipo === t ? (t === 'entrada' ? cores.green : cores.red) : cores.border}`,
                  borderRadius: 8, background: movTipo === t ? (t === 'entrada' ? '#d1f5e0' : '#fde8e8') : 'white',
                  cursor: 'pointer', fontWeight: 600, fontSize: 14,
                  color: movTipo === t ? (t === 'entrada' ? '#155724' : '#991b1b') : cores.muted
                }}>
                  {t === 'entrada' ? '📥 Entrada' : '📤 Saida'}
                </button>
              ))}
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Quantidade *</label>
              <input type="number" value={movQtd} onChange={e => setMovQtd(e.target.value)} placeholder="0" style={inputStyle} />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={labelStyle}>Observacao</label>
              <textarea value={movObs} onChange={e => setMovObs(e.target.value)} rows={2} placeholder="Ex: Compra do fornecedor..." style={{ ...inputStyle, resize: 'vertical' }} />
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setShowModalMov(false)} style={{ ...btnGhost, flex: 1 }}>Cancelar</button>
              <button onClick={registrarMovimentacao} style={{ ...btnPrimary, flex: 1, background: movTipo === 'entrada' ? cores.green : cores.red }}>
                {movTipo === 'entrada' ? 'Registrar Entrada' : 'Registrar Saida'}
              </button>
            </div>
          </Modal>

          {/* MODAL HISTORICO */}
          <Modal show={showModalDetalhe} onClose={() => setShowModalDetalhe(false)} title={`Historico — ${produtoSel?.nome}`}>
            {movimentacoes.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 32, color: cores.muted }}>
                <div style={{ fontSize: 40 }}>📭</div>
                <p>Nenhuma movimentacao</p>
              </div>
            ) : movimentacoes.map(m => (
              <div key={m.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: `1px solid ${cores.border}` }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14, color: m.tipo === 'entrada' ? cores.green : cores.red }}>
                    {m.tipo === 'entrada' ? '📥' : '📤'} {m.tipo === 'entrada' ? 'Entrada' : 'Saida'} de {parseFloat(m.quantidade)} un.
                  </div>
                  <div style={{ fontSize: 12, color: cores.muted }}>{m.observacao}</div>
                  <div style={{ fontSize: 11, color: cores.muted }}>{m.usuario_nome} · {new Date(m.criado_em).toLocaleDateString('pt-BR')}</div>
                </div>
              </div>
            ))}
          </Modal>
        </>
      )}

      {/* ── ABA CATÁLOGO ── */}
      {subAba === 'catalogo' && podeVerCatalogo && (
        <>
          <div style={{ ...cardStyle, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
            <div>
              <div style={{ fontWeight: 700, fontSize: 16 }}>📋 Catálogo de Fornecedores</div>
              <div style={{ fontSize: 12, color: cores.muted, marginTop: 2 }}>Produtos de referência — sem controle de quantidade</div>
            </div>
            {isEst && (
              <button onClick={() => { setCatNome(''); setCatCategoria(''); setCatFornecedor(''); setCatValorPago(''); setCatPercLucro(''); setCatValorVenda(''); setShowModalCatNovo(true); }} style={btnPrimary}>
                + Novo Produto
              </button>
            )}
          </div>

          {/* RESUMO */}
          {!isFuncionario && (() => {
            const fmt = v => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            const cats = [...new Set(catalogo.map(p => p.fornecedor).filter(Boolean))].length;
            return (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 16 }}>
                {[
                  ['Total Produtos', catalogo.length, cores.navy],
                  ['Fornecedores', cats, cores.orange],
                  ['Categorias', [...new Set(catalogo.map(p => p.categoria).filter(Boolean))].length, '#7c3aed'],
                ].map(([label, val, cor]) => (
                  <div key={label} style={{ background: 'white', borderRadius: 14, padding: 14, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', borderLeft: `4px solid ${cor}` }}>
                    <div style={{ fontSize: 11, color: cores.muted, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>{label}</div>
                    <div style={{ fontSize: 20, fontWeight: 700 }}>{val}</div>
                  </div>
                ))}
              </div>
            );
          })()}

          {/* BUSCA */}
          <div style={{ ...cardStyle, padding: '12px 16px' }}>
            <input value={buscaCat} onChange={e => setBuscaCat(e.target.value)}
              placeholder="Buscar por nome, categoria ou fornecedor..."
              style={{ ...inputStyle, border: 'none', outline: 'none', fontSize: 14 }} />
          </div>

          {/* LISTA */}
          <div style={cardStyle}>
            {catalogoFiltrado.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 32, color: cores.muted }}>
                <div style={{ fontSize: 40 }}>📋</div>
                <p>Nenhum produto no catálogo</p>
              </div>
            ) : catalogoFiltrado.map(p => (
              <div key={p.id} style={{ padding: '14px 0', borderBottom: `1px solid ${cores.border}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 10 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4 }}>{p.nome}</div>
                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                      {p.categoria && <span style={{ fontSize: 12, background: cores.navyL, color: cores.navyD, padding: '2px 8px', borderRadius: 12, fontWeight: 600 }}>{p.categoria}</span>}
                      {p.fornecedor && <span style={{ fontSize: 12, color: cores.muted }}>🏭 {p.fornecedor}</span>}
                      {!isFuncionario && p.valor_pago && <span style={{ fontSize: 13 }}>Custo: <b>R$ {parseFloat(p.valor_pago).toFixed(2).replace('.', ',')}</b></span>}
                      {!isFuncionario && p.percentual_lucro && <span style={{ fontSize: 13 }}>Lucro: <b>{parseFloat(p.percentual_lucro).toFixed(1)}%</b></span>}
                      {!isFuncionario && <span style={{ fontSize: 13 }}>Venda: <b style={{ color: cores.orange }}>R$ {parseFloat(p.valor_venda || 0).toFixed(2).replace('.', ',')}</b></span>}
                    </div>
                  </div>
                  {isEst && (
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button onClick={() => abrirEdicaoCatalogo(p)} style={{ padding: '5px 10px', background: '#f0f3f7', border: `1px solid ${cores.border}`, borderRadius: 6, fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>Editar</button>
                      <button onClick={() => removerCatalogo(p.id)} style={{ padding: '5px 10px', background: '#fde8e8', border: '1px solid #f5b7b1', borderRadius: 6, fontSize: 12, cursor: 'pointer', color: '#c0392b', fontWeight: 600 }}>Remover</button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* MODAL NOVO PRODUTO CATÁLOGO */}
          <Modal show={showModalCatNovo} onClose={() => setShowModalCatNovo(false)} title="Novo Produto — Catálogo" bloqueado={!!(catNome || catValorPago)}>
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Nome *</label>
              <input value={catNome} onChange={e => setCatNome(e.target.value)} placeholder="Ex: Switch TP-Link 24 portas" style={inputStyle} autoFocus />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div>
                <label style={labelStyle}>Categoria</label>
                <input value={catCategoria} onChange={e => setCatCategoria(e.target.value)} placeholder="Ex: Redes" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Fornecedor</label>
                <input value={catFornecedor} onChange={e => setCatFornecedor(e.target.value)} placeholder="Ex: TP-Link" style={inputStyle} />
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>NCM <span style={{ fontSize: 10, color: cores.muted, fontWeight: 400 }}>(usado na emissão de NF-e)</span></label>
              <input value={catNcm} onChange={e => setCatNcm(e.target.value.replace(/\D/g,'').slice(0,8))} placeholder="Ex: 84713012" maxLength={8} style={inputStyle} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div>
                <label style={labelStyle}>CSOSN <span style={{ fontSize: 10, color: cores.muted, fontWeight: 400 }}>(Simples Nacional)</span></label>
                <select value={catCsosn} onChange={e => setCatCsosn(e.target.value)} style={inputStyle}>
                  <option value="">— Selecionar —</option>
                  <option value="102">102 — Sem permissão de crédito</option>
                  <option value="400">400 — Sem ST</option>
                  <option value="500">500 — Com ST (mais comum)</option>
                  <option value="900">900 — Outros</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>CFOP</label>
                <select value={catCfop} onChange={e => setCatCfop(e.target.value)} style={inputStyle}>
                  <option value="5102">5102 — Venda de mercadoria</option>
                  <option value="5405">5405 — Venda com ST</option>
                  <option value="5949">5949 — Outra saída</option>
                  <option value="6102">6102 — Venda interestadual</option>
                </select>
              </div>
            </div>
            {!isFuncionario && (
              <>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
                  <div>
                    <label style={labelStyle}>Custo (R$)</label>
                    <input type="number" step="0.01" value={catValorPago} onChange={e => handleCatValorPago(e.target.value)} placeholder="0,00" style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>% Lucro</label>
                    <input type="number" step="0.01" value={catPercLucro} onChange={e => handleCatPercLucro(e.target.value)} placeholder="0" style={inputStyle} />
                  </div>
                </div>
                <div style={{ marginBottom: 20, padding: 12, background: '#fff3eb', borderRadius: 8 }}>
                  <label style={{ ...labelStyle, color: cores.orange }}>Valor de Venda (R$) — editável</label>
                  <input type="number" step="0.01" value={catValorVenda} onChange={e => handleCatValorVenda(e.target.value)}
                    placeholder="0,00" style={{ ...inputStyle, fontWeight: 700, color: cores.orange, borderColor: cores.orange }} />
                </div>
              </>
            )}
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setShowModalCatNovo(false)} style={{ ...btnGhost, flex: 1 }}>Cancelar</button>
              <button onClick={criarCatalogo} style={{ ...btnPrimary, flex: 1 }}>Adicionar ao Catálogo</button>
            </div>
          </Modal>
          <Modal show={showModalCatEdit} onClose={() => setShowModalCatEdit(false)} title="Editar — Catálogo" bloqueado={true}>
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Nome *</label>
              <input value={catNome} onChange={e => setCatNome(e.target.value)} style={inputStyle} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div>
                <label style={labelStyle}>Categoria</label>
                <input value={catCategoria} onChange={e => setCatCategoria(e.target.value)} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Fornecedor</label>
                <input value={catFornecedor} onChange={e => setCatFornecedor(e.target.value)} style={inputStyle} />
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>NCM <span style={{ fontSize: 10, color: cores.muted, fontWeight: 400 }}>(usado na emissão de NF-e)</span></label>
              <input value={catNcm} onChange={e => setCatNcm(e.target.value.replace(/\D/g,'').slice(0,8))} placeholder="Ex: 84713012" maxLength={8} style={inputStyle} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
              <div>
                <label style={labelStyle}>CSOSN <span style={{ fontSize: 10, color: cores.muted, fontWeight: 400 }}>(Simples Nacional)</span></label>
                <select value={catCsosn} onChange={e => setCatCsosn(e.target.value)} style={inputStyle}>
                  <option value="">— Selecionar —</option>
                  <option value="102">102 — Sem permissão de crédito</option>
                  <option value="400">400 — Sem ST</option>
                  <option value="500">500 — Com ST (mais comum)</option>
                  <option value="900">900 — Outros</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>CFOP</label>
                <select value={catCfop} onChange={e => setCatCfop(e.target.value)} style={inputStyle}>
                  <option value="5102">5102 — Venda de mercadoria</option>
                  <option value="5405">5405 — Venda com ST</option>
                  <option value="5949">5949 — Outra saída</option>
                  <option value="6102">6102 — Venda interestadual</option>
                </select>
              </div>
            </div>
            {!isFuncionario && (
              <>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
                  <div>
                    <label style={labelStyle}>Custo (R$)</label>
                    <input type="number" step="0.01" value={catValorPago} onChange={e => handleCatValorPago(e.target.value)} style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>% Lucro</label>
                    <input type="number" step="0.01" value={catPercLucro} onChange={e => handleCatPercLucro(e.target.value)} style={inputStyle} />
                  </div>
                </div>
                <div style={{ marginBottom: 20, padding: 12, background: '#fff3eb', borderRadius: 8 }}>
                  <label style={{ ...labelStyle, color: cores.orange }}>Valor de Venda (R$) — editável</label>
                  <input type="number" step="0.01" value={catValorVenda} onChange={e => handleCatValorVenda(e.target.value)}
                    placeholder="0,00" style={{ ...inputStyle, fontWeight: 700, color: cores.orange, borderColor: cores.orange }} />
                </div>
              </>
            )}
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setShowModalCatEdit(false)} style={{ ...btnGhost, flex: 1 }}>Cancelar</button>
              <button onClick={editarCatalogo} style={{ ...btnPrimary, flex: 1 }}>Salvar</button>
            </div>
          </Modal>
        </>
      )}

      {/* ── ABA EQUIPAMENTOS ── */}
      {subAba === 'equipamentos' && (
        <>
          <div style={{ ...cardStyle, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
            <div style={{ fontWeight: 700, fontSize: 16 }}>🔧 Equipamentos e Ferramentas</div>
            {isEst && (
              <button onClick={() => { setEquipNome(''); setEquipQtd(1); setShowModalEquip(true); }} style={btnPrimary}>
                + Novo Equipamento
              </button>
            )}
          </div>

          {/* Resumo */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 12, marginBottom: 16 }}>
            <div style={{ background: 'white', borderRadius: 14, padding: 14, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', borderLeft: `4px solid ${cores.navy}` }}>
              <div style={{ fontSize: 11, color: cores.muted, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>Total Itens</div>
              <div style={{ fontSize: 20, fontWeight: 700 }}>{equipamentos.length}</div>
            </div>
            <div style={{ background: 'white', borderRadius: 14, padding: 14, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', borderLeft: `4px solid ${cores.orange}` }}>
              <div style={{ fontSize: 11, color: cores.muted, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>Técnicos</div>
              <div style={{ fontSize: 20, fontWeight: 700 }}>{Object.keys(equipAgrupados).length}</div>
            </div>
          </div>

          {/* Busca */}
          <div style={{ ...cardStyle, padding: '12px 16px' }}>
            <input value={buscaEquip} onChange={e => setBuscaEquip(e.target.value)}
              placeholder="Buscar por equipamento ou técnico..."
              style={{ ...inputStyle, border: 'none', outline: 'none', fontSize: 14 }} />
          </div>

          {/* Lista agrupada por técnico */}
          {equipamentos.length === 0 ? (
            <div style={{ ...cardStyle, textAlign: 'center', padding: 48, color: cores.muted }}>
              <div style={{ fontSize: 48 }}>🔧</div>
              <p>Nenhum equipamento cadastrado</p>
            </div>
          ) : buscaEquip ? (
            // Modo busca — lista flat
            <div style={cardStyle}>
              {equipFiltrados.map(eq => (
                <EquipamentoItem key={eq.id} eq={eq} usuario={usuario} isEst={isEst}
                  onTransferir={abrirTransferencia} onRemover={removerEquipamento} cores={cores} />
              ))}
            </div>
          ) : (
            // Modo normal — agrupado por técnico
            Object.entries(equipAgrupados).map(([tecnico, itens]) => (
              <div key={tecnico} style={cardStyle}>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 12, color: cores.navy, display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ width: 32, height: 32, borderRadius: '50%', background: cores.navyL, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: cores.navy }}>
                    {tecnico.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()}
                  </div>
                  {tecnico}
                  <span style={{ fontSize: 12, color: cores.muted, fontWeight: 400 }}>({itens.length} item{itens.length !== 1 ? 's' : ''})</span>
                </div>
                {itens.map(eq => (
                  <EquipamentoItem key={eq.id} eq={eq} usuario={usuario} isEst={isEst}
                    onTransferir={abrirTransferencia} onRemover={removerEquipamento} cores={cores} />
                ))}
              </div>
            ))
          )}

          {/* MODAL NOVO EQUIPAMENTO */}
          <Modal show={showModalEquip} onClose={() => setShowModalEquip(false)} title="Novo Equipamento">
            <div style={{ marginBottom: 14 }}>
              <label style={labelStyle}>Nome *</label>
              <input value={equipNome} onChange={e => setEquipNome(e.target.value)}
                placeholder="Ex: Furadeira Bosch, Alicate..." style={inputStyle} autoFocus />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={labelStyle}>Quantidade</label>
              <input type="number" min="1" value={equipQtd} onChange={e => setEquipQtd(e.target.value)}
                placeholder="1" style={inputStyle} />
            </div>
            <div style={{ padding: '10px 14px', background: '#f5f7fa', borderRadius: 8, marginBottom: 20, fontSize: 13, color: cores.muted }}>
              📌 Será cadastrado como seu equipamento (<strong style={{ color: cores.navy }}>{usuario?.nome}</strong>)
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setShowModalEquip(false)} style={{ ...btnGhost, flex: 1 }}>Cancelar</button>
              <button onClick={criarEquipamento} style={{ ...btnPrimary, flex: 1 }}>Cadastrar</button>
            </div>
          </Modal>

          {/* MODAL TRANSFERÊNCIA */}
          <Modal show={showModalTransf} onClose={() => setShowModalTransf(false)} title={`Transferir — ${equipSel?.nome}`}>
            <div style={{ marginBottom: 16, padding: '10px 14px', background: '#f5f7fa', borderRadius: 8, fontSize: 13, color: cores.muted }}>
              Atualmente com: <strong style={{ color: cores.navy }}>{equipSel?.responsavel_nome}</strong>
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={labelStyle}>Transferir para *</label>
              <select value={transfPara} onChange={e => setTransfPara(e.target.value)} style={inputStyle}>
                <option value="">Selecione o técnico...</option>
                {usuarios.filter(u => u.id !== equipSel?.responsavel_id).map(u => (
                  <option key={u.id} value={u.id}>{u.nome}</option>
                ))}
              </select>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setShowModalTransf(false)} style={{ ...btnGhost, flex: 1 }}>Cancelar</button>
              <button onClick={transferirEquipamento} style={{ ...btnPrimary, flex: 1 }}>Transferir</button>
            </div>
          </Modal>
        </>
      )}
    </div>
  );
}

// Componente auxiliar para item de equipamento
function EquipamentoItem({ eq, usuario, isEst, onTransferir, onRemover, cores }) {
  const ehMeu = eq.responsavel_id === usuario?.id;
  const podeEditar = isEst && ehMeu;

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: `1px solid ${cores.border}`, gap: 10 }}>
      <div>
        <div style={{ fontWeight: 600, fontSize: 14 }}>{eq.nome}</div>
        <div style={{ fontSize: 12, color: cores.muted }}>Quantidade: {eq.quantidade}</div>
      </div>
      <div style={{ display: 'flex', gap: 6 }}>
        {podeEditar && (
          <>
            <button onClick={() => onTransferir(eq)} style={{ padding: '5px 10px', background: '#eef2ff', border: '1px solid #c7d2fe', borderRadius: 6, fontSize: 12, cursor: 'pointer', color: '#3730a3', fontWeight: 600 }}>
              🔄 Transferir
            </button>
            <button onClick={() => onRemover(eq.id)} style={{ padding: '5px 10px', background: '#fde8e8', border: '1px solid #f5b7b1', borderRadius: 6, fontSize: 12, cursor: 'pointer', color: '#c0392b', fontWeight: 600 }}>
              Remover
            </button>
          </>
        )}
      </div>
    </div>
  );
}
